import * as React from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"
import { capitalize } from "lodash"
import { StatusIndicator } from "components-design-system"
// context
import useWorkflowTracker from "context/hooks/useWorkflowTracker"

// styles
import "./TrackerStatus.scss"

const TrackerStatus = ({ model, status }) => {
  const { isWorkflowComplete, isWorkflowCancelled, trackerData } = useWorkflowTracker()

  const detailProps = React.useMemo(() => {
    let currentStateIndex = trackerData.findIndex((state) => state.is_current)
    let nextState = trackerData?.[currentStateIndex + 1] ? trackerData[currentStateIndex + 1] : null

    let res = {
      dueInDays: 0,
      detailStyle: {
        color: "#D7542C",
        fontSize: 13,
        marginTop: 2,
      },
      detailIconClassName: "far fa-clock",
      details: `${nextState?.state_title || ""} due in ${0} day(s)`,
    }

    let today = dayjs()
    let nextStartDate = dayjs(nextState?.start_date)

    if (nextStartDate) {
      res.dueInDays = nextStartDate.diff(today, "days")
      if (res.dueInDays > 20) res.detailStyle.color = "#70AD2E"
      if (res.dueInDays < 0) res.dueInDays = 0
    }

    if (isWorkflowComplete) {
      res.details = `${capitalize(model)} Complete`
      res.detailStyle.color = "#70AD2E"
    } else if (isWorkflowCancelled) {
      res.detailStyle.color = "#D7542C"
      res.details = `${capitalize(model)} Cancelled`
      res.detailIconClassName = "fal fa-times-circle"
    }

    return res
  }, [trackerData])

  return (
    <div className="tracker-status">
      <div
        className="tracker-status-box current-status"
        style={{ borderRight: "1px solid rgba(56, 62, 71, 0.3)" }}
      >
        {model === "activity" && (
          <StatusIndicator.Risk
            className="status-indicator"
            status={status}
          />
        )}
        <div className="text">{status === "Not at Risk" ? "On Track" : status}</div>
      </div>
      <div className="tracker-status-box final-status">
        <i
          className={detailProps.detailIconClassName}
          style={detailProps.detailStyle}
        ></i>
        <div
          className="text"
          style={{ color: detailProps.detailStyle.color }}
        >
          {detailProps.details}
        </div>
      </div>
    </div>
  )
}

TrackerStatus.propTypes = {
  model: PropTypes.string, // activity or request
  status: PropTypes.string, // on track, not at risk, etc.
}

export default TrackerStatus
